import React, { useEffect, useState } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { useField } from '@unform/core';

type TVTextFieldProps = TextFieldProps & {
  name: string;
  calcular?: (novoValor: number) => void;
};

export const VFieldMoneynumber: React.FC<TVTextFieldProps> = ({ calcular, name, ...rest }) => {

  const { fieldName, registerField, defaultValue, error, clearError } = useField(name);

  const [value, setValue] = useState<string>(defaultValue || '');

  useEffect(() => {
    registerField({
      name: fieldName,

      // Aqui enviamos NUMBER para o formulário
      getValue: () => formatToNumber(value),

      setValue: (_, newValue) => {
        setValue(formatToMoney(String(newValue)));
      },
    });
  }, [registerField, fieldName, value]);

  // ---- CONVERTE STRING EM NUMBER ----
  const formatToNumber = (val: string): number => {
    if (!val) return 0;

    // remove tudo que não for dígito
    const clean = val.replace(/\./g, '').replace(',', '.');

    return Number(clean);
  };

  // ---- FORMATA STRING PARA VISUALIZAÇÃO ----
  const formatToMoney = (val: string): string => {
    val = val.replace(/\D/g, '');
    val = val.replace(/(\d)(\d{2})$/, '$1,$2');
    val = val.replace(/(?=(\d{3})+(\D))\B/g, '.');
    return val;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFormatted = formatToMoney(e.target.value);
    setValue(newFormatted);

    const numberValue = formatToNumber(newFormatted);

    calcular?.(numberValue);

    rest.onChange?.(e);
  };

  return (
    <TextField
      {...rest}
      error={!!error}
      helperText={error}
      value={value}
      onChange={handleChange}
      onKeyDown={(e) => {
        if (error) clearError();
        rest.onKeyDown?.(e);
      }}
    />
  );
};
